(function($, undefined) {

	$.nette.ext('jsFilter', {
		init: function() {
			var snippetsExt = $.nette.ext('snippets');
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));

		}
	}, {
		selector: '.js-filter',
		init: function ($el) {
			var $filter = $el.find(this.selector);

			$filter.each(function() {
				setTimeout(() => {
					var $ul = $(this).find('ul');
					var $liText = $(this).find('.js-filter-text');
					var $input = $(this).find('input.js-filter-input');
					var $visible = $([]);
					var $notFound = $('<li class="msg py-1 px-2 u-d-f u-ai-b u-bgc-gray-200 u-bdr">' + $(this).data('js-filter-noresults') + '</li>');

					var filter = '';

					$input.keyup(function () {
						filter = $(this).val().toUpperCase();

						$liText.removeHighlight();

						if (filter === '') {
							$liText.closest('li').show();
						}
						else {
							$liText.closest('li').hide();
							$visible = $liText.filter(function () {
								if ($(this).text().toUpperCase().indexOf(filter) > -1) {
									$(this).highlight(filter);
									return true;
								}

								return false;
							}).closest('li');

							if ($visible.length === 0) {
								$ul.append($notFound);
							}
							else {
								$notFound.remove();
							}

							$visible.show();
						}

					}).triggerHandler('keyup');

					$input.on('keypress',function(e) {
						if (e.which === 13) {
							e.preventDefault();
						}
					});
				}, 0)
			});
		}
	});

})(jQuery);
